import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '@/views/Login.vue';
import Logout from '@/views/Logout.vue';
import AppFast from '@/views/AppFast.vue';

import DeliveryIndex from '@/views/Delivery/Index.vue';
import DeliveryList from '@/views/Delivery/DeliveryList.vue';
import DeliveryCreate from '@/views/Delivery/CreateOrder.vue';
import DeliveryCreateByWeight from '@/views/Delivery/CreateOrderByWeight.vue';
import DeliveryCreateFlatRate from '@/views/Delivery/CreateOrderFlatRate.vue';
import DeliveryEdit from '@/views/Delivery/EditOrder.vue';
import DeliveryFlatRateEdit from '@/views/Delivery/EditFlatRateOrder.vue';
import DeliveryInformation from '@/views/Delivery/Information.vue';
import DeliveryImport from '@/views/Delivery/ImportCSV.vue';
import WaitingDeliveryList from '@/views/Delivery/WaitingOrder.vue';
import WaitingDeliveryCreate from '@/views/Delivery/CreateDeliveryFromTemp.vue';
import ReceivableList from '@/views/Delivery/ReceivableList.vue';
import CancelDeliveryList from '@/views/Delivery/CancelOrder.vue';
import DeliveryTypeSelect from '@/views/Delivery/OrderTypeSelect.vue';

import OverallIndex from '@/views/Overall/Index.vue';
import OverallDashboard from '@/views/Overall/Dashboard.vue';
import OverallTotal from '@/views/Overall/Total.vue';
import OverallHubTotal from '@/views/Overall/HubTotal.vue';

import ProductIndex from '@/views/Product/Index.vue';
import ProductList from '@/views/Product/ProductList.vue';
import CreateProduct from '@/views/Product/CreateProduct.vue';
import CreateProductType from '@/views/Product/CreateProductType.vue';
import UpdateProduct from '@/views/Product/UpdateProduct.vue';

import ReportIndex from '@/views/Report/Index.vue';
import ReportList from '@/views/Report/List.vue';
import ReportCSVRouter from '@/views/Report/CSV/csv-report-router';

import ManagementIndex from '@/views/Report/Management/Index.vue';
import ManagementRouter from '@/views/Report/Management/management-router';

import SettingIndex from '@/views/Setting/Index.vue';
import SettingCompany from '@/views/Setting/Company.vue';

import SettingAreaList from '@/views/Setting/AreaCode/List.vue';
import SettingAreaCreator from '@/views/Setting/AreaCode/Create.vue';
import SettingAreaEditor from '@/views/Setting/AreaCode/Edit.vue';

import SettingUser from '@/views/Setting/User/Index.vue';
import SettingUserList from '@/views/Setting/User/List.vue';
import SettingUserNew from '@/views/Setting/User/New.vue';
import SettingUserEdit from '@/views/Setting/User/Edit.vue';

import SettingUsage from '@/views/Setting/Usage.vue';

import Profile from '@/views/Profile/Index.vue';
import ProfileSetting from '@/views/Profile/Profile.vue';
import ProfileSystemDisplay from '@/views/Profile/SystemDisplay.vue';
import ProfileCompanyStatistic from '@/views/Profile/Statistics.vue';

import Tracking from '@/views/Tracking/Tracking.vue';
import AppUpdateTrackingStatus from '@/views/Tracking/UpdateTracking.vue';

import Error from '../views/Error.vue';

Vue.use(VueRouter);

// const guardAuth = async (to: Route, from: Route, next: (route?: any) => void) => {
//   next();
// };

const routes = [
  { // when from: login single field, provide company logo unless main domain
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  {
    path: '/tracking',
    name: 'Tracking',
    component: Tracking,
  },
  {
    path: '/android-preview/:id',
    name: 'AppUpdateTrackingStatus',
    component: AppUpdateTrackingStatus,
  },
  {
    path: '/app',
    // beforeEnter: guardAuth, // Check only root, no need to check children
    component: AppFast,
    redirect: { name: 'DeliveryImport' },
    children: [
      {
        path: 'dashboard',
        component: OverallDashboard,
        name: 'Dashboard',
      },
      {
        path: 'delivery',
        component: DeliveryIndex,
        children: [
          {
            path: 'cancel',
            name: 'CancelDeliveryList',
            component: CancelDeliveryList,
          },
          {
            path: 'type-select',
            name: 'DeliveryTypeSelect',
            component: DeliveryTypeSelect,
          },
          {
            path: 'waiting',
            name: 'WaitingIndex',
            component: DeliveryIndex,
            children: [
              {
                path: '',
                name: 'WaitingDeliveryList',
                component: WaitingDeliveryList,
              },
              {
                path: 'create/:id',
                name: 'WaitingDeliveryCreate',
                component: WaitingDeliveryCreate,
              },
            ],
          },
          {
            path: 'create',
            name: 'DeliveryCreate',
            component: DeliveryCreate,
          },
          {
            path: 'create-by-weight',
            name: 'DeliveryCreateByWeight',
            component: DeliveryCreateByWeight,
          },
          {
            path: 'create-flat-rate',
            name: 'DeliveryCreateFlatRate',
            component: DeliveryCreateFlatRate,
          },
          {
            path: 'edit/:id',
            name: 'DeliveryEdit',
            component: DeliveryEdit,
          },
          {
            path: 'edit-flat-rate/:id',
            name: 'DeliveryFlatRateEdit',
            component: DeliveryFlatRateEdit,
          },
          {
            path: 'import',
            name: 'DeliveryImport',
            component: DeliveryImport,
          },
          {
            path: 'list',
            name: 'DeliveryList',
            component: DeliveryList,
          },
          {
            path: 'receivable',
            name: 'ReceivableList',
            component: ReceivableList,
          },
          {
            path: ':id',
            name: 'DeliveryInformation',
            component: DeliveryInformation,
          },
        ],
      },
      {
        path: 'product',
        component: ProductIndex,
        redirect: { name: 'ProductList' },
        children: [
          {
            path: '',
            name: 'ProductList',
            component: ProductList,
          },
          {
            path: 'create-product',
            name: 'CreateProduct',
            component: CreateProduct,
          },
          {
            path: 'create-product-type',
            name: 'CreateProductType',
            component: CreateProductType,
          },
          {
            path: 'update-product/:id',
            name: 'UpdateProduct',
            component: UpdateProduct,
          },
        ],
      },
      {
        path: 'report',
        component: ReportIndex,
        children: [
          {
            path: 'management',
            component: ManagementIndex,
            name: 'ManagementIndex',
            children: ManagementRouter,
          },
          // {
          //   path: 'report/analytics',
          //   component: AnalyticsIndex,
          //   name: 'AnalyticsIndex',
          //   children: AnalyticsRouter,
          // },
          {
            path: 'report-list',
            name: 'ReportList',
            component: ReportList,
            children: [
              ...ReportCSVRouter,
            ],
          },
        ],
      },
      {
        path: 'setting',
        component: SettingIndex,
        children: [
          {
            // ตั้งค่าบริษัท
            path: 'componay',
            name: 'SettingCompany',
            component: SettingCompany,
          },
          {
            // ตั้งค่า Area code
            path: 'area',
            redirect: { name: 'SettingArea' },
            component: SettingIndex,
            children: [
              {
                path: '',
                name: 'SettingArea',
                component: SettingAreaList,
              },
              {
                path: 'create',
                name: 'SettingAreaCreator',
                component: SettingAreaCreator,
              },
              {
                path: 'edit/:id',
                name: 'SettingAreaEditor',
                component: SettingAreaEditor,
              },
            ],
          },
          {
            // ดูประวัติการใช้งาน
            path: 'usage',
            name: 'SettingUsage',
            component: SettingUsage,
          },
          {
            // ตั้งค่าข้อมูลผู้ใช้
            path: 'user',
            name: 'UserIndex',
            component: SettingUser,
            redirect: { name: 'User' },
            children: [
              {
                path: '',
                name: 'User',
                component: SettingUserList,
              },
              {
                path: ':roleId',
                name: 'UserList',
                component: SettingUserList,
              },
              {
                path: ':initRole/new',
                name: 'UserNew',
                component: SettingUserNew,
              },
              {
                path: 'edit/:id',
                name: 'UserEdit',
                component: SettingUserEdit,
              },
            ],
          },
        ],
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        children: [
          {
            path: 'setting',
            name: 'ProfileSetting',
            component: ProfileSetting,
          },
          {
            path: 'system',
            name: 'SystemDisplay',
            component: ProfileSystemDisplay,
          },
          {
            path: 'static',
            name: 'CompanyStatistic',
            component: ProfileCompanyStatistic,
          },
        ],
      },
    ],
  },
  { path: '*', component: Error },
];

const router = new VueRouter({
  routes,
});

export default router;
